import styled from 'styled-components';
// import palette from '../../lib/styles/palette';
import ProjectHeaderContainer from './ProjectHeaderContainer';
import SideMenu from './SideMenu';

const ProjectTemplateBlock = styled.div`
    .body {
        display: flex;
    }
    .content {
        width: 100%;
        margin: 2rem;
        overflow-x: auto;
    }
`;

const ProjectTemplate = ({ children }) => {
    return (
        <ProjectTemplateBlock>
            <ProjectHeaderContainer />
            <div className="body">
                <SideMenu />
                <div className="content">{children}</div>
            </div>
        </ProjectTemplateBlock>
    );
};

export default ProjectTemplate;
